enum IndividualData_SectionName {

    ContactInfo = "contact_info_data",
    FurtherAddressen = "further_addresses",
    PersonalInfo = "personal_info_data",
    PassportInfo = "passport_data",
    PersonalDocumentsInfo = "personal_documents",
    FinancialInsuranceInfo = "financial_insurance_data",
    BankInfo = "bank_data",
    BioInfo_DE = "bio_data_de",
    BioInfo_EN = "bio_data_en",
    NewFurtherAddress = "new_further_address"
}

(globalThis as any).IndividualData_SectionName = IndividualData_SectionName; // (mds A11) seed runtime value for cross-file bare refs

enum IndividualData_File {

    PassportScan = "passport_scan",
    VatExemption = "VAT_exemption_doc"
}

(globalThis as any).IndividualData_File = IndividualData_File; // (mds A11) seed runtime value for cross-file bare refs

interface IndividualData_Bio {
    bio_html: string
}

interface IndividualData_BasicInfoSheet {
    contact_info_data: {
        infoHTML: string
    },
    personal_info_data: {
        infoHTML: string
    },
    passport_data: {
        infoHTML: string,
        passId: string
    },
    financial_insurance_data: {
        infoHTML: string,
        is_VAT_exemption: boolean
    },
    bank_data: {
        infoHTML: string
    },
    //provision_data: {
    //    infoHTML: string
    //},
    //tax_data: {
    //    infoHTML: string,
    //    is_VAT_exemption: boolean
    //},
    //other_data: {
    //    infoHTML: string
    //},
    bio_data_de: {
        infoHTML: string
    },
    bio_data_en: {
        infoHTML: string
    }
}

interface IndividualData_CollapsedSections {
    sectionName: string,
    isCollapsed: boolean
}

interface IndividualData_ContactInfo {
    name: string,
    name_first: string,
    street: string,
    c_city: string,
    c_postal_code: string,
    country: string,
    postal_code: IndividualData_PostalCode,
    phone: string,
    mobile_phone: string,
    email: string
}

interface IndividualData_ContactSave {
    name: string,
    name_first: string,
    street: string,
    postal_code_id: string,
    postal_code: string,
    city: string,
    country: string,
    phone: string,
    mobile_phone: string,
    email: string
}
interface IndividualData_FurtherAddressessInfo {
    ID: string,
    description: string,
    is_active: boolean,
    street: string,
    c_city: string,
    c_postal_code: string,
    ref_country: {
        ID: string
    },
    ref_postal_code: IndividualData_PostalCode,
    ref_vw_telecom_addresses: {
        phonenumber: string,
        mobilenumber: string,
        emailaddress: string
    }
}

interface IndividualData_FurtherAddressessSave {
    is_new: boolean,
    ID: string,
    description: string,
    street: string,
    postal_code_id: string,
    postal_code: string,
    city: string,
    country: string,
    phone: string,
    mobile_phone: string,
    email: string
}
interface IndividualData_PostalCode {
    ID: string,
    postal_code: string,
    gDisp_1: string,
    city: string,
    ref_country: {
        ID: string,
        description: string
    }
}

interface IndividualData_PersonalInfoSave {
    citizenship: string,
    family_status: string,
    day_of_birth: Date,
    place_of_birth: string,
}

interface IndividualData_PersonalInfo {
    citizenship: {
        ID: string,
        description: string
    },
    family_status: {
        ID: string,
        description: string
    },
    day_of_birth: Date,
    place_of_birth: string,
}

interface IndividualData_PassportInfo {
    ID: string,
    is_active: boolean,
    personal_doc_number: string,
    issued_authority_original: string,
    date_valid_from: string,
    date_valid_until: string,
}

interface IndividualData_PassportSave {
    personal_doc_number: string,
    issued_country: string,
    issued_authority_original: string,
    date_valid_from: Date,
    date_valid_until: Date,
    is_main_document: boolean
}

interface IndividualData_PersonalDocumentInfo {
    ID: string,
    Classname: string,
    is_active: boolean,
    personal_doc_number: string,
    issued_authority_original: string,
    date_valid_from: string,
    date_valid_until: string,
}

interface IndividualData_PersonalDocumentSave {
    document_type: string, 
    personal_doc_number: string,
    issued_country: string,
    issued_authority_original: string,
    date_valid_from: Date,
    date_valid_until: Date,
    is_main_document: boolean
}

interface IndividualData_FinancialInsuranceInfo {
    further_addresses: Array<IndividualData_FurtherAddress>,
    financial_insurance_data: IndividualData_FinancialData
}

interface IndividualData_FurtherAddress {
    ID: string,
    is_active: boolean,
    is_active_tax_address:boolean,
    street: string,
    ref_postal_code: {
        ID: string,
        postal_code: string,
        city: string
    },
    ref_country: {
        ID: string,
        description: string
    }
}

interface IndividualData_FinancialData {
    social_insurance_no: string,
    tax_no: string,
    tax_id_no: string,
    VAT_no: string,
    is_VAT_exemption: boolean,
    is_contact_address_tax_address:boolean
}

interface IndividualData_FinancialInsuranceDataSave {
    social_insurance_no: string,
    tax_no: string,
    tax_id_no: string,
    VAT_no: string,
    is_VAT_exemption: boolean,
    is_contact_address_tax_address: boolean,
    further_address_id: string
}

interface IndividualData_NewFurtherAddressSave {
    description: string,
    street: string,
    postal_code_id: string,
    postal_code: string,
    city: string,
    country_id: string
}

interface IndividualData_BankInfo {
    ID: string,
    is_active: boolean,
    is_default_business_account: boolean,
    ref_bank: IndividualData_BankBranchDetails,
    account_no: string,
    IBAN: string
}

interface IndividualData_BankBranchDetails {
    ID: string,
    bank_name: string,
    city: string,
    bank_number: string,
    bank_BIC: string,
    gDisp_1?: string,
    ref_country?: {
        ID: string,
        description: string
    }
}

interface IndividualData_BankBranchSave {
    account_no: string,
    IBAN: string,
    bank_id: string,
    bank_BIC: string,
    bank_number: string,
    bank_name: string,
    city: string,
    country: string
}

interface IndividualData_ProvisionInfo {
    ID: string,
    description: string,
}

interface IndividualData_TaxInfoSheet {
    tax_no: string,
    VAT_no: string,
    VAT_exemption: boolean,
}

interface IndividualData_OtherInfoSheet {
    test: string,
}

interface IndividualData_BioInfoSheet {
    biography_de: HTMLTextAreaElement,
    biography_en: HTMLTextAreaElement,
}
